module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newMassage) ? _c('div', {
    staticClass: "Valert"
  }, [_c('div', [_c('h5', [_vm._v("信息提示"), _c('div', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "Valert-content"
  }, [_c('p', [_c('i'), _c('span', [_vm._v(_vm._s(_vm.newMassage))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("确认")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b841a2da","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component/alert.vue
// module id = 57
// module chunks = 70